// Store links. Google Play is live; add APP_STORE_URL when the iOS app is uploaded.
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=app.emergent.pricefinder4321568af87";
export const APP_STORE_URL = "";
export const SUPPORT_EMAIL = "support@sellcraft.app";
